import { render, staticRenderFns } from "./tune.vue?vue&type=template&id=12f96228&"
import script from "./tune.vue?vue&type=script&lang=js&"
export * from "./tune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f96228')) {
      api.createRecord('12f96228', component.options)
    } else {
      api.reload('12f96228', component.options)
    }
    module.hot.accept("./tune.vue?vue&type=template&id=12f96228&", function () {
      api.rerender('12f96228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/tune.vue"
export default component.exports